import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import ApplicationForm from '../ApplicationForm';
import Container from '../Container';
import Loading from '../Loading';
import toPounds from '../helpers/price';
import styles from './course.css';

const { div, p, header, h1, ol, li } = hh(h);

const Course = ({ data: { loading, course }, ...props }) => {
    if (loading) return h(Loading);

    return (
        h(Container, [
            div({className: styles.container}, [
                ol({className: styles.grid}, [
                    li({className: styles.cell}, [
                        h1({className: styles.cellHeading}, '1'),
                        p({className: styles.cellText}, 'Apply below')]),
                    li({className: styles.cell}, [
                        h1({className: styles.cellHeading}, '2'),
                        p({className: styles.cellText}, 'We’ll review your application and pick the most motivated students.')]),
                    li({className: styles.cell}, [
                        h1({className: styles.cellHeading}, '3'),
                        p({className: styles.cellText}, `If you are offered a place then you will need to pay the tuition fee of £${toPounds(course.price)} to secure your place.`)])
                ]),
                header({className: styles.header}, [
                    p({className: styles.detail}, 'Apply to the'),
                    p({className: styles.course}, course.name),
                    p({className: styles.detail}, 'course at'),
                    p({className: styles.university}, course.university.name)]),
                h(ApplicationForm, {course})])])
    );
};

export default graphql(gql`
    query Course($courseId: String!) {
        course(id: $courseId) {
            id
            name
            price
            description

            questions {
                edges {
                    order
                    node {
                        id
                        type
                        title
                        ui
                        schema
                    }
                }
            }
            university {
                id
                name
            }
        }
    }
`, {
    options({params: { id }}) {
        return { variables: { courseId: id } };
    }
})(Course);



/** WEBPACK FOOTER **
 ** ./src/Course/index.js
 **/